<div style="display:flex; flex-direction:column; align-items:center">
  <h1>New Purchase Order</h1>
  <div style="padding: 10px; display:flex; gap:20px;">
    <div style="display:flex; flex-direction:column; align-items:center; gap:10px">
      <button mat-button class="btn-bg-green" (click)="onNewPO();"><mat-icon>add</mat-icon>New Single PO</button>
      <button mat-mini-fab class="btn-bg-blue" (click)="generatePdf()" title="Print PO Worksheet"><mat-icon>picture_as_pdf</mat-icon></button>
    </div>
    <div style="display:flex; flex-direction:column; align-items:center; gap:10px">
      <button mat-button class="btn-bg-green" (click)="onNewMultiPO()"><mat-icon>content_copy</mat-icon>New Spread PO</button>
      <button mat-mini-fab class="btn-bg-blue" (click)="generatePdf()" title="Print Spread PO Worksheet"><mat-icon>picture_as_pdf</mat-icon></button>
    </div>
  </div>
  <button style="width:100%" mat-button class="btn-bg-red" (click)="onCancel()">Cancel</button>
</div>
@if(PrintPOPDF){
<div #pdfContainer class="print-container-landscape">
  <ng-container *ngIf="inventoryFormComponentType">
    <ng-container *ngComponentOutlet="inventoryFormComponentType; inputs: { Pdf: true }"></ng-container>
  </ng-container>
</div>
}
